import { useEffect, useState } from "react";
import { Col, Row, Button, Pagination, Card } from "react-bootstrap";
import { useGetSubscriptionPurchasesByShopQuery } from "../../features/shop/shopApiSlice";
import { useNavigate, useParams } from "react-router-dom";
import ShopAdds from "../shopAds/ShopAdds";
import OwnerPropertyViewModel from "../ShopViewModel/OwnerPropertyViewModel";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Suggestion from "../../pages/suggestion";
import { useGetUserPropertiesQuery, useDeletePropertyMutation } from "../../features/property/propertyApiSlice";
import RedoIcon from "@mui/icons-material/Redo";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import Suggestionmodal from "../../pages/suggestionmodal";
import ShareModel from "../Sharemodel";
import ShareOption from "../Shareoption";
import { useSelector } from "react-redux";
import { getAsset } from "../../helpers/helper";
import ReportBox from "../Report/index";
import dummyezi from "../../assets/images/dummy/dummyezi.png";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import MainModal from "../ui/modal/modal";

const PropertyItemsCard = ({
  urlPass,
  shopid,
  post,
  suggest,
  setSuggest,
  suggestdata,
  shopData,
}) => {
  const { name } = useSelector((state) => state.user);
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: purchaseResponse } = useGetSubscriptionPurchasesByShopQuery(
    shopid || id,
    { skip: !(shopid || id) }
  );
  const subscriptionData = purchaseResponse?.data || purchaseResponse;
  const isHiredSuccess = subscriptionData?.paymentStatus === "success";
  const currentPlan = ["Free", "Basic", "Standard", "Premium"].includes(
    subscriptionData?.planId?.planName,
  )
    ? subscriptionData.planId.planName
    : null;

  const marketerUserId = localStorage.getItem("MeAsmarketerUserId");
  const userId = name?._id?.toString();
  const isOwnerOverride = marketerUserId && userId && marketerUserId === userId;
  const shopUserId = shopData?.userid?._id?.toString?.() || shopData?.userid?.toString?.();
  const isOwner = Boolean(userId && shopUserId && shopUserId === userId);

  const canPostItems =
    Boolean(post) &&
    (isOwner ||
      isOwnerOverride ||
      (isHiredSuccess &&
        (currentPlan === "Standard" || currentPlan === "Premium")));

  const [properties, setProperties] = useState([]);
  const [showshare, setShowshare] = useState(0);
  const [shows, setShows] = useState(false);
  const [show, setShow] = useState(0);
  const [suggestId, setSuggestId] = useState();
  const [suggestid, setSuggestid] = useState("");
  const [shareItemId, setShareItemId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [dummyItems, setDummyItems] = useState(100);
  const itemsPerPage = 50;

  const handleClose = () => setShows(0);

  const totalItems = Math.max(properties?.length || 0, 100);
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = properties?.slice(indexOfFirstItem, indexOfLastItem);
  const currentDummyCount = Math.max(0, 100 - (currentItems?.length || 0));

  localStorage.setItem("suggestid", suggestId);

  const { data: propertiesRes } = useGetUserPropertiesQuery({ userid: name?._id, companyid: id }, { skip: !name?._id });

  useEffect(() => {
    if (propertiesRes?.success) {
      setProperties(propertiesRes?.data?.Companies || []);
    }
  }, [propertiesRes]);

  useEffect(() => {
    setDummyItems(Math.max(0, 100 - (properties?.length || 0)));
  }, [properties]);

  const handleSelect = (key) => {
    if (key === "ps") {
      navigate(post);
    }
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const [deleteProperty] = useDeletePropertyMutation();

  const Deleteitem = async () => {
    try {
      const response = await deleteProperty(suggestid).unwrap();
      if (response?.success) {
        SuccessNotify("Item Deleted Successfully");
        setShows(0);
      }
    } catch (error) {
      FailedNotify("Failed to Delete Try Again!");
      setShows(0);
    }
  };

  const suggestsingleid = localStorage.getItem("suggestid");

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const renderItems = () => {
    const renderedItems = [];
    const dummyImageSources = [{ src: dummyezi, key: "dummy-1" }];

    // 🔹 ACTUAL PROPERTY CARDS (Redesigned for new layout)
    if (currentItems?.length > 0) {
      currentItems.forEach((Items) => {
        renderedItems.push(
          <Col xs={12} className="mb-4" key={Items?._id}>
            <Card className="propertyItemLarge-card shadow-sm border-0 rounded-4 overflow-hidden">
              <Row className="g-0 align-items-center">
                {/* Left side image */}
                <Col xs={12} md={5}>
                  <div className="propertyItemLarge-img-container">
                    <Card.Img
                      variant="top"
                      src={Items?.image && Items.image.length > 0 ? getAsset(Items?.image[0]) : noImagePlaceholder}
                      alt={Items?.subCategory}
                      crossOrigin="anonymous"
                      className="propertyItemLarge-img"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noImagePlaceholder;
                      }}
                    />
                  </div>
                </Col>

                {/* Right side content */}
                <Col xs={12} md={7}>
                  <Card.Body className="propertyItemLarge-body">
                    <Card.Title className="text-capitalize fw-bold mb-2">
                      {Items?.subCategory}
                    </Card.Title>

                    <div className="propertyItemLarge-rating mb-2">
                      ⭐⭐⭐☆☆
                    </div>

                    <Card.Text className="text-muted mb-3">
                       {Items?.description?.length > 160
                  ? `${Items?.description?.substring(0, 160)}...read more`
                  : Items?.description}
                    </Card.Text>

                    <div className="text-primary fw-semibold mb-4 fs-5">
                      {Items?.currency?.slice(0, 3)} : {Items?.price}
                    </div>

                    <div className="d-flex gap-2 mt-2">
                      <Button
                        variant="primary"
                        className="w-100 py-2 fw-semibold propertyItemLarge-viewBtn pt-1 pb-1"
                        onClick={() => {
                          navigate(`${urlPass}/${shopid}/${Items._id}`);
                          setSuggestid(Items?._id);
                        }}
                      >
                        View
                      </Button>
                      <Button
                        variant="outline-primary"
                        className="w-100 py-2 fw-semibold pt-1 pb-1"
                        onClick={() => {
                          setShareItemId(Items?._id);
                          setShow(1);
                        }}
                      >
                        Share <RedoIcon style={{ fontSize: "1rem" }} />
                      </Button>
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        );
      });
    }

    // 🔹 DUMMY PLACEHOLDER CARDS (same design)
    Array.from({ length: currentDummyCount }).forEach((_, index) => {
      const dummy = dummyImageSources[index % dummyImageSources.length];
      renderedItems.push(
        <Col xs={12} className="mb-4" key={`dummy-${index}-${indexOfFirstItem}`}>
          <Card className="propertyItemLarge-card shadow-sm border-0 rounded-4 overflow-hidden text-center">
            <Row className="g-0 align-items-center">
              <Col xs={12} md={5}>
                <div className="propertyItemLarge-img-container">
                  <Card.Img
                    variant="top"
                    src={dummy.src}
                    alt="Dummy Item"
                    className="propertyItemLarge-img"
                    style={{ objectFit: "contain" }}
                  />
                </div>
              </Col>

              <Col xs={12} md={7}>
                <Card.Body className="propertyItemLarge-body d-flex flex-column justify-content-center align-items-center">
                  <Card.Title className="fw-bold text-muted mb-2">
                    Post item to see here
                  </Card.Title>
                  <div className="propertyItemLarge-rating opacity-50">
                    ⭐⭐⭐☆☆
                  </div>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Col>
      );
    });

    return renderedItems;
  };

  return (
    <>
      {shows === 1 && (
        <MainModal
          variant="deleteModal"
          show={shows}
          title="Item"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem}
        />
      )}
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        handleClosemodal={handleClosemodal}
        show={show}
        handleShowshare={handleShowshare}
        shareurl={shareItemId ? `/single-property-addview/${shareItemId}` : ""}
      />
      <div className="ms-3 ps-0 pe-0 ms-0 me-0 property-items-root">
        <ShopAdds back="/SellingSide" />
        <div className="shops-container">
          {suggest === 1 ? (
            <Suggestionmodal
              setSuggestId={setSuggestId}
              setSuggest={setSuggest}
              suggest={suggest}
              suggestdata={suggestdata}
              shopid={shopid}
            />
          ) : suggest === 2 ? (
            <ReportBox setSuggest={setSuggest} suggest={suggest} />
          ) : suggest === 3 ? (
            <Suggestion
              suggestsingleid={suggestsingleid}
              suggestdata={suggestdata}
              shopData={shopData}
              setSuggest={setSuggest}
            />
          ) : (
            <Tabs
              defaultActiveKey="Items"
              id="uncontrolled-tab-example"
              className="px-4 pooost"
              onSelect={handleSelect}
            >
              <Tab eventKey="Items" title="Items" className="jobviewhead">
                <div className="shop-scroll">
                  <Row className="ps-2 pe-4">
                    {properties?.length > 0 || currentDummyCount > 0 ? (
                      <>
                        {renderItems()}
                        {currentItems?.length === 0 &&
                          currentDummyCount === 0 && (
                            <h4 className="text-center">No items found</h4>
                          )}
                      </>
                    ) : (
                      <h4 className="text-center">No items found</h4>
                    )}
                  </Row>

                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                      <Pagination>
                        <Pagination.Prev
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        />
                        {Array.from({ length: totalPages }, (_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPage}
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </div>
                  )}
                </div>
              </Tab>
              {canPostItems && (
                <Tab eventKey="ps" title="&#10133; Post Item" />
              )}
            </Tabs>
          )}
        </div>
      </div>
    </>
  );
};

export default PropertyItemsCard;
